"use client";

interface ClickableLocationProps {
  location: string;
  className?: string;
}

export function ClickableLocation({
  location,
  className = "text-foreground font-normal underline cursor-pointer hover:text-gray-700 transition-colors text-left",
}: ClickableLocationProps) {
  const handleClick = () => {
    const mapSection = document.getElementById("map-section");
    if (mapSection) {
      mapSection.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={className}
      aria-label={`Scroll to map showing ${location}`}
    >
      {location}
    </button>
  );
}
